import { render, staticRenderFns } from "./SlideoutShoppingBasket.vue?vue&type=template&id=4a8295eb&scoped=true&"
import script from "./SlideoutShoppingBasket.vue?vue&type=script&lang=js&"
export * from "./SlideoutShoppingBasket.vue?vue&type=script&lang=js&"
import style0 from "./SlideoutShoppingBasket.vue?vue&type=style&index=0&id=4a8295eb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8295eb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/induline.salamander.live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a8295eb')) {
      api.createRecord('4a8295eb', component.options)
    } else {
      api.reload('4a8295eb', component.options)
    }
    module.hot.accept("./SlideoutShoppingBasket.vue?vue&type=template&id=4a8295eb&scoped=true&", function () {
      api.rerender('4a8295eb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/ui/SlideoutShoppingBasket.vue"
export default component.exports